import { render, staticRenderFns } from "./WorkFlowCategoryList.vue?vue&type=template&id=60d24e80&scoped=true&"
import script from "./WorkFlowCategoryList.vue?vue&type=script&lang=js&"
export * from "./WorkFlowCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./WorkFlowCategoryList.vue?vue&type=style&index=0&id=60d24e80&prod&lang=scss&scoped=true&"
import style1 from "./WorkFlowCategoryList.vue?vue&type=style&index=1&id=60d24e80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d24e80",
  null
  
)

export default component.exports